import Vue from 'vue'
import axios from 'axios'
import store from '../store'
import moment from 'moment'

axios.defaults.baseURL = process.env.VUE_APP_PLATFORM_ROOT_URL
axios.defaults.headers.common.Accept = 'application/json'
axios.defaults.headers.post['Content-Type'] = 'application/json'

Vue.$http = axios
Object.defineProperty(Vue.prototype, '$http', {
  get () {
    return axios
  }
})

axios.interceptors.request.use((config) => {
  if (store.state.auth.authenticated && store.state.auth.expDate) {
    let currentTime = moment()
    let expDate = moment.unix(store.state.auth.expDate)

    if (currentTime.isAfter(expDate)) {
      store.dispatch('auth/logout')
      location.reload()
    }
  }

  return config
},
error => {
  Promise.reject(error)
})
